/**
 * IdleWarningDialog Component
 *
 * Shows a modal popup when the user has been idle and is about to be signed out.
 * Displays a countdown and a "Continue" button to stay signed in.
 *
 * Requirements: 12.3, 12.4, 12.5
 */

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

export function IdleWarningDialog() {
    const { showIdleWarning, idleCountdown, staySignedIn } = useAuth();

    if (!showIdleWarning) return null;

    const minutes = Math.floor(idleCountdown / 60);
    const seconds = idleCountdown % 60;
    const timeDisplay = minutes > 0
        ? `${minutes}:${seconds.toString().padStart(2, '0')}`
        : `${seconds} seconds`;

    return (
        <Dialog
            open={showIdleWarning}
            onClose={staySignedIn}
            aria-labelledby="idle-warning-title"
            data-testid="idle-warning-dialog"
        >
            <DialogTitle id="idle-warning-title">
                Are you still there?
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    You will be signed out in <strong>{timeDisplay}</strong> due to inactivity.
                    Click Continue to stay signed in.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={staySignedIn}
                    variant="contained"
                    autoFocus
                    data-testid="idle-warning-continue"
                    sx={{ '&:focus-visible': { outline: 'none' } }}
                >
                    Continue
                </Button>
            </DialogActions>
        </Dialog>
    );
}
